var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayMyBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2013_1962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.178 30.118H3.732C2.833 30.118 1.878 30.187 2.097 30.973C2.316 31.759 8.243 38.927 8.452 39.25C8.766 39.734 9.188 40.105 10.087 40.105L24.036 40.252L40.303 34.696C40.846 34.42 38.535 30.284 38.007 30C37.998 29.995 37.988 29.99 37.979 29.985L22.179 30.118H22.178Z",
    fill: "#172535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.434 33.503H16.988C16.089 33.503 15.134 33.572 15.353 34.358C15.572 35.144 21.499 42.312 21.708 42.635C22.022 43.119 22.444 43.637 23.343 43.637H37.292L35.434 33.502V33.503Z",
    fill: "#172535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.98 31.597V10.37C34.98 9.91699 34.73 9.50199 34.331 9.28799C33.932 9.07399 9.842 9.07499 9.442 9.28799C9.043 9.50199 8.793 9.91799 8.793 10.37V39.012C8.793 39.465 9.043 39.88 9.442 40.094C9.842 40.308 29.03 40.247 29.03 40.247L34.98 31.597Z",
    fill: "#FD6A3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.594 23.464C12.916 23.454 12.359 23.996 12.349 24.674C12.339 25.352 12.881 25.909 13.559 25.919C13.571 25.919 13.582 25.919 13.594 25.919H30.181C30.859 25.929 31.416 25.387 31.426 24.709C31.436 24.031 30.894 23.474 30.216 23.464C30.204 23.464 30.193 23.464 30.181 23.464H13.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.594 28.323C12.916 28.313 12.359 28.855 12.349 29.533C12.339 30.211 12.881 30.768 13.559 30.778C13.571 30.778 13.582 30.778 13.594 30.778H18.931C19.609 30.788 20.166 30.246 20.176 29.568C20.186 28.89 19.644 28.333 18.966 28.323C18.954 28.323 18.943 28.323 18.931 28.323H13.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.594 33.181C12.916 33.171 12.359 33.713 12.349 34.391C12.339 35.069 12.881 35.626 13.559 35.636C13.571 35.636 13.582 35.636 13.594 35.636H17.686C18.364 35.646 18.921 35.104 18.931 34.426C18.941 33.748 18.399 33.191 17.721 33.181C17.709 33.181 17.698 33.181 17.686 33.181H13.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.594 18.606C12.916 18.596 12.359 19.138 12.349 19.816C12.339 20.494 12.881 21.051 13.559 21.061C13.571 21.061 13.582 21.061 13.594 21.061H17.686C18.364 21.071 18.921 20.529 18.931 19.851C18.941 19.173 18.399 18.616 17.721 18.606C17.709 18.606 17.698 18.606 17.686 18.606H13.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.594 13.747C12.916 13.737 12.359 14.279 12.349 14.957C12.339 15.635 12.881 16.192 13.559 16.202C13.571 16.202 13.582 16.202 13.594 16.202H17.686C18.364 16.212 18.921 15.67 18.931 14.992C18.941 14.314 18.399 13.757 17.721 13.747C17.709 13.747 17.698 13.747 17.686 13.747H13.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.973 28.839H24.541C23.0752 28.839 21.887 30.0272 21.887 31.493V40.984C21.887 42.4498 23.0752 43.638 24.541 43.638H39.973C41.4388 43.638 42.627 42.4498 42.627 40.984V31.493C42.627 30.0272 41.4388 28.839 39.973 28.839Z",
    fill: "#172535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.627 32.404H21.887V35.448H42.627V32.404Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.097 39.354C34.419 39.344 33.862 39.886 33.852 40.564C33.842 41.242 34.384 41.799 35.062 41.809C35.074 41.809 35.085 41.809 35.097 41.809H39.189C39.867 41.819 40.424 41.277 40.434 40.599C40.444 39.921 39.902 39.364 39.224 39.354C39.212 39.354 39.201 39.354 39.189 39.354H35.097Z",
    fill: "#FD6A3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.337 11.962C32.069 11.97 31.814 12.082 31.626 12.274L25.465 18.435L22.75 15.72C22.355 15.308 21.7 15.295 21.288 15.69C20.876 16.085 20.863 16.74 21.258 17.152C21.268 17.162 21.278 17.172 21.288 17.182L24.734 20.628C25.138 21.032 25.792 21.032 26.196 20.628L33.088 13.736C33.497 13.338 33.506 12.683 33.107 12.274C32.905 12.067 32.626 11.954 32.337 11.962Z",
    fill: "#172535"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2013_1962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayMyBill);
export default __webpack_public_path__ + "static/media/payMyBill.80c48dda33b1e8b0c9d69500b869ef47.svg";
export { ForwardRef as ReactComponent };